import type { EsmsOverview } from '../../types/esms';
import InfoTooltip from '../revenue/InfoTooltip';

function formatVND(v: number): string { return v.toLocaleString('en-US'); }
function formatNum(v: number): string { return v.toLocaleString('en-US'); }

export default function EsmsOverviewCards({ overview, isDark }: { overview: EsmsOverview; isDark: boolean }) {
  const cards = [
    { label: 'Số dư tài khoản', value: `${formatVND(overview.balance)} VND`, color: overview.balance < 0 ? 'text-rose-400' : 'text-emerald-400', tooltip: 'Số dư hiện tại của tài khoản eSMS. Âm = đang nợ cước. UserID: ' + (overview.userId ?? 'n/a') + '.\n\n📡 Nguồn: eSMS GetBalance_json' },
    { label: 'Tổng SMS gửi', value: formatNum(overview.totalSms), color: 'text-cyan-400', tooltip: 'Tổng số SMS đã gửi trong kỳ (tất cả SmsType).\n\n📡 Nguồn: eSMS GetSmsSentData_V2, count SentData' },
    { label: 'Tổng chi phí', value: `${formatVND(overview.totalCost)} VND`, color: 'text-amber-400', tooltip: 'Tổng chi phí SMS trong kỳ = Σ SellPrice.\n\n📡 Nguồn: eSMS GetSmsSentData_V2' },
    { label: 'Tỷ lệ gửi thành công', value: `${overview.successRate.toFixed(2)}%`, color: 'text-emerald-400', tooltip: `Thành công: ${formatNum(overview.totalSuccess)} / ${formatNum(overview.totalSms)}.\nThất bại/chưa gửi: ${formatNum(overview.totalFailed)}.\n\nSendResult=1 tính là success.` },
  ];

  return (
    <div className={`backdrop-blur rounded-lg p-4 sm:p-6 ${isDark ? 'bg-white/10' : 'bg-white border border-gray-200 shadow-sm'}`}>
      <h3 className={`text-lg font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Tổng quan eSMS</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {cards.map((c) => (
          <div key={c.label} className={`rounded-lg p-3 ${isDark ? 'bg-white/5' : 'bg-gray-50 border border-gray-100'}`}>
            <p className={`text-xs ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
              {c.label}
              <InfoTooltip isDark={isDark} text={c.tooltip} />
            </p>
            <p className={`text-lg font-bold font-mono mt-1 ${isDark ? c.color : 'text-gray-900'}`}>{c.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
